<template>

    <div class="search">

        <div class="search__body" v-if="searchValue">

            <p class="color__charcoal"
               :class="{
                'text-baseMedium': !isDesktop,
                'text-xlSemibold-2': isDesktop
            }">
                {{ computedTextSearching }}
            </p>

            <p class="color__moon mt__8"
               :class="{
                'text-lRegular': !isDesktop,
                'text-lMedium': isDesktop
            }"
               v-show="list.length === 0">{{ $t('cleaning_search_suggestion') }}</p>
        </div>

    </div>

</template>

<script>
import Tag from '@/modules/tag'

export default {

    name: 'search',

    props: {
        list: {
            type: Array,
            default: () => []
        },
        searchValue: {
            type: String,
            default: ''
        }
    },

    watch: {
        list() {
            if (this.searchValue && this.list.length === 0) {
                Tag.clickGA(this, 'search_result_empty')
            }
        }
    },

    computed: {

        computedTextSearching() {
            return this.list.length
                ? this.$tc('cleaning_search_nb_results', this.list.length, {search: this.searchValue})
                : this.$t('cleaning_search_no_results')
        }
    }
}

</script>

<style lang="scss" scoped>

.search {
    @media screen and (min-width: $above-tablet-length) {
        background-color: $white;
    }

    &__body {
        display: flex;
        flex-direction: column;
        background-color: $timberwolf;
        padding: 16px 16px 8px;
        text-align: left;
        @media screen and (min-width: $above-tablet-length) {
            background-color: $white;
            text-align: center;
            margin-top: 57px;
        }
    }

    &__title {
        display: flex;
        flex-direction: row;
    }
}
</style>